import { dineInAxios } from "@/axios-path.js";
export default {
  namespaced: true,
  state: {
    store_list: [],
    productListByStore: [],
    orderListOnProcess: [],
    orderListNewOrder: [],
    storeCategoryList: [],
    review_list: [],
    campaign_review_benefit_list: [],
  },
  mutations: {
    getAllDineInStore(state, data) {
      state.store_list = data;
    },
    getAllDineInReviews(state, data) {
      state.review_list = data;
    },
    setProductListByStore(state, productList) {
      state.productListByStore = productList;
    },
    setRemoveDineInProduct(state, productID) {
      let index = state.productListByStore.findIndex(val => val.product_id == productID);
      state.productListByStore.splice(index, 1)
    },
    setOrderList(state, orderList) {
      state.orderListOnProcess = orderList.filter(val => val.order_status == 2)
      state.orderListNewOrder = orderList.filter(val => val.order_status == 1)
    },
    changeStatusOrderOnProcess(state, order_id) {
      let index = state.orderListOnProcess.findIndex(val => val.order_id == order_id)
      state.orderListOnProcess.splice(index, 1)
    },
    changeStatusOrderNewOrder(state, order_id) {
      let index = state.orderListNewOrder.findIndex(val => val.order_id == order_id)
      state.orderListNewOrder.splice(index, 1)
    },
    setStoreCategory(state, categoryList) {
      state.storeCategoryList = categoryList;
    },
    addStoreCategory(state, categoryItem) {
      state.storeCategoryList.push(categoryItem)
    },
    editStoreCategory(state, categoryItem) {
      let index = state.storeCategoryList.findIndex(val => val.store_category_id == categoryItem.store_category_id)
      console.log(index);
      state.storeCategoryList.splice(index, 1, categoryItem)
    },
    deleteStoreCategory(state, category_id) {
      let index = state.storeCategoryList.findIndex(val => val.store_category_id == category_id)
      state.storeCategoryList.splice(index, 1)
    },
    setCampaignReviewBenefitList(state, list) {
      state.campaign_review_benefit_list = list
    },
    addCampaignReviewBenefitList(state, data) {
      state.campaign_review_benefit_list.push(data)
    },
    deleteCampaignReviewBenefitList(state, campaign_review_id) {
      let index = state.campaign_review_benefit_list.findIndex(val => val.campaign_review_id == campaign_review_id);
      state.campaign_review_benefit_list.splice(index, 1)
    },
    editCampaignReviewBenefitList(state, payload) {
      let index = state.campaign_review_benefit_list.findIndex(val => val.campaign_review_id == payload.campaign_review_id);
      let item = state.campaign_review_benefit_list[index];
      Object.assign(item, payload)

      let constConvertToMinutes = {
        'day': 1440,
        'hour': 60
      }

      if (item.campaign_review_reward_life_span.unit == 'day')
        item.campaign_review_reward_life_span = item.campaign_review_reward_life_span.amount * constConvertToMinutes.day
      else if (item.campaign_review_reward_life_span.unit == 'hour')
        item.campaign_review_reward_life_span = item.campaign_review_reward_life_span.amount * constConvertToMinutes.hour
      else if (item.campaign_review_reward_life_span.unit == 'minute')
        item.campaign_review_reward_life_span = item.campaign_review_reward_life_span.amount


      state.campaign_review_benefit_list.splice(index, 1, item)
    },
  },
  getters: {
    autocompleteStoreDinein(state) {
      let store_list = [];
      for (let val of state.store_list) {
        store_list.push({
          store_id: val.store_id,
          store_name_th: val.store_name_th ? val.store_name_th : "",
        });
      }
      return store_list;
    },
  },
  actions: {
    async createDineInStore({ }, payload) {
      let url = "/api/v1/management/store/dinein";
      return dineInAxios
        .post(url, payload.data)
        .then((res) => {
          if (res.msg === false) return false;
          return true;
        })
        .catch((error) => false);
    },
    async getAllDineInStore({ commit }, payload) {
      let url = "/api/v1/getall/store/dinein";
      return dineInAxios
        .get(url, { params: payload })
        .then((res) => {
          if (res.msg === false) return false;
          else {
            commit("getAllDineInStore", res.data);
            return res.data;
          }
        })
        .catch((error) => false);
    },
    async getDineInStoreById({ }, id) {
      let url = "/api/v1/management/store/dinein";
      return dineInAxios
        .get(url, { params: { store_id: id } })
        .then((res) => {

          if (res.msg === false) return false;
          return res.data;
        })
        .catch((error) => false);
    },
    async updateDineInStore({ }, payload) {
      let url = "/api/v1/management/store/dinein";
      return dineInAxios
        .put(url, payload.data)
        .then(async (res) => {
          if (res.msg === false) return false;
          else return true;
        })
        .catch((error) => false);
    },
    async deleteDineInStore({ }, id) {
      let url = "/api/v1/management/store/dinein?store_id=" + id;
      return dineInAxios
        .delete(url)
        .then((res) => {
          if (res.msg === false) return false;
          return true;
        })
        .catch((error) => false);
    },
    async updateStoreList({ commit }, lists) {
      commit("getAllDineInStore", lists);
    },
    async getDineInStoreTimeById({ }, id) {
      let url = "/api/v1/management/store/day/dinein";
      return dineInAxios
        .get(url, { params: { store_id: id } })
        .then((res) => {
          if (res.msg === false) return false;
          return res.data;
        })
        .catch((error) => false);
    },
    async updateDineInStoreTime({ }, payload) {
      let url = "/api/v1/management/store/day/dinein";
      return dineInAxios
        .put(url, payload.data)
        .then((res) => {
          if (res.msg === false) return false;
          return true;
        })
        .catch((error) => false);
    },
    async createDineInStoreType({ }, payload) {
      let url = "/api/v1/management/store_type";
      return dineInAxios
        .post(url, payload.data)
        .then((res) => {
          if (res.msg === true) return true;
          return false;
        })
        .catch((error) => false);
    },
    async updateDineInStoreType({ }, payload) {
      let url = "/api/v1/management/store_type";
      return dineInAxios
        .put(url, payload.data)
        .then((res) => {
          return res.msg;
        })
        .catch((error) => false);
    },
    async getDineInStoreType({ }) {
      let url = "/api/v1/management/store_type";
      return dineInAxios
        .get(url)
        .then((res) => {
          if (res.msg === false) return false;
          return res.data;
        })
        .catch((error) => false);
    },
    async deleteDineInStoreType({ }, id) {
      let url = "/api/v1/management/store_type?store_type_id=" + id;
      return dineInAxios
        .delete(url)
        .then((res) => {
          return res;
        })
        .catch((error) => false);
    },
    fetchProductList({ commit }, { storeID }) {
      let url = "/api/v1/dine-in/store/products";
      return dineInAxios
        .get(url)
        .then((res) => {
          if (res.msg === false) return false;
          let resultList = res.data.filter(val => val.product_store_id == storeID)
          commit('setProductListByStore', resultList)
          return resultList;
        })
        .catch((error) => false);
    },
    fetchProductByID({ }, productID) {
      let url = `/api/v1/dine-in/store/products/${productID}`;
      return dineInAxios
        .get(url)
        .then((res) => {
          if (res.msg === false) return false;
          return res.data;
        })
        .catch((error) => false);
    },
    createProductDinein({ commit }, { form, imageSrc, packageImageSrc }) {
      let url = `/api/v1/dine-in/store/products`;
      //secondsToTimeFormat
      let hours = Math.floor(form.time_limit / 3600);
      let minutes = Math.floor((form.time_limit - (hours * 3600)) / 60);
      let seconds = form.time_limit - (hours * 3600) - (minutes * 60);

      if (hours < 10) { hours = "0" + hours; }
      if (minutes < 10) { minutes = "0" + minutes; }
      if (seconds < 10) { seconds = "0" + seconds; }
      //secondsToTimeFormat

      let payload = {
        "name_th": form.product_name_th,
        "name_en": form.product_name_en,
        "base_price": form.product_base_price,
        "course": form.product_course_amount,
        "minimum_amount": form.product_minimum_person,
        "maximum_amount": form.product_maximum_person,
        "menu_image": form.image_menu,
        "image": form.image,
        "description_th": form.product_description_th,
        "description_en": form.product_description_en,
        "booking_expiration": form.product_booking_expiration,
        "store_id": form.product_store_id,
        "time_limit": hours + ':' + minutes + ':' + seconds,
        "discount": form.discount.map(val => {
          return {
            "value": val.discount_value,
            "unit": val.discount_unit,
            "start_date": val.discount_start_date,
            "end_date": val.discount_end_date
          }
        })
      }
      payload.menu_image = [...imageSrc, ...payload.menu_image]
      payload.image = [...packageImageSrc, ...payload.image]
      return dineInAxios
        .post(url, payload)
        .then((res) => {
          if (res.msg === false) return false;
          let resultList = res.data.filter(val => val.product_store_id == form.product_store_id)
          commit('setProductListByStore', resultList)
          return res.data;
        })
        .catch((error) => false);
    },
    editProductByID({ commit }, { form, imageSrc, packageImageSrc }) {
      let url = `/api/v1/dine-in/store/products/${form.product_id}`;
      //secondsToTimeFormat
      let hours = Math.floor(form.time_limit / 3600);
      let minutes = Math.floor((form.time_limit - (hours * 3600)) / 60);
      let seconds = form.time_limit - (hours * 3600) - (minutes * 60);

      if (hours < 10) { hours = "0" + hours; }
      if (minutes < 10) { minutes = "0" + minutes; }
      if (seconds < 10) { seconds = "0" + seconds; }
      //secondsToTimeFormat
      let payload = {
        "name_th": form.product_name_th,
        "name_en": form.product_name_en,
        "base_price": form.product_base_price,
        "course": form.product_course_amount,
        "minimum_amount": form.product_minimum_person,
        "maximum_amount": form.product_maximum_person,
        "menu_image": form.image_menu,
        "image": form.image,
        "description_th": form.product_description_th,
        "description_en": form.product_description_en,
        "booking_expiration": form.product_booking_expiration,
        "store_id": form.product_store_id,
        "time_limit": hours + ':' + minutes + ':' + seconds,
        "discount": form.discount.map(val => {
          return {
            "value": val.discount_value,
            "unit": val.discount_unit,
            "start_date": val.discount_start_date,
            "end_date": val.discount_end_date
          }
        })
      }
      payload.menu_image = [...imageSrc, ...payload.menu_image]
      payload.image = [...packageImageSrc, ...payload.image]
      return dineInAxios
        .put(url, payload)
        .then((res) => {
          if (res.msg === false) return false;
          let resultList = res.data.filter(val => val.product_store_id == form.product_store_id)
          commit('setProductListByStore', resultList)
          return res.data;
        })
        .catch((error) => false);
    },
    updateStatusProductByID({ }, { status, productID }) {
      let url = `/api/v1/dine-in/store/products/${productID}/status/${status == true ? 1 : 0}`;
      return dineInAxios
        .put(url, {})
        .then((res) => {
          return res.msg;
        })
        .catch((error) => false);
    },
    removeDineInProduct({ commit }, { productID }) {
      let url = `/api/v1/dine-in/store/products/${productID}`;
      return dineInAxios
        .delete(url)
        .then((res) => {
          commit('setRemoveDineInProduct', productID)
          return res.msg;
        })
        .catch((error) => false);
    },
    fetchOrderList({ commit }, { order_status, datetime_dine_in }) {
      let url = `/api/v1/dine-in/office/orders`;
      return dineInAxios
        .get(url, { params: { order_status: JSON.stringify(order_status), datetime_booking: datetime_dine_in } })
        .then((res) => {
          if (res.msg == false) return false;
          if (order_status.includes(1) || order_status.includes(2)) {
            commit('setOrderList', res.data)
          }
          return res.data;
        })
        .catch((error) => false);
    },
    fetchOrderDetail({ }, { order_id }) {
      let url = `/api/v1/dine-in/office/orders/${order_id}`;
      return dineInAxios
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          return res.data;
        })
        .catch((error) => false);
    },
    completeOrder({ commit }, { order_id, order_status }) {
      let url = `/api/v1/dine-in/office/completeOrder/${order_id}`;
      let payload = {
        "order_status": "complete"
      }
      return dineInAxios
        .put(url, payload)
        .then((res) => {
          if (order_status == 1) {
            commit('changeStatusOrderNewOrder', order_id)
          } else if (order_status == 2) {
            commit('changeStatusOrderOnProcess', order_id)
          }
          return res.msg;
        })
        .catch((error) => {
          if (error.response.data.msg == false) {
            if (error.response.data.data == "Can complete only after Dine-in time") {
              alert("Can not complete order because it's not date/time to dine in yet.")
            }
          }
          return false;
        });
    },
    cancelOrder({ commit }, { order_id, order_status, order_note = '' }) {
      let url = `/api/v1/dine-in/office/orders/${order_id}`;
      let payload = {
        "order_status": "cancel",
        order_note_cancel: order_note
      }
      return dineInAxios
        .put(url, payload)
        .then((res) => {
          if (order_status == 1) {
            commit('changeStatusOrderNewOrder', order_id)
          } else if (order_status == 2) {
            commit('changeStatusOrderOnProcess', order_id)
          }
          return res.msg;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    updateOrderDetailDineIn({ commit }, form) {
      let url = `/api/v1/dine-in/office/orders/update`;
      let payload = {
        order_id: form.order_id,
        product_id: form.product_id,
        qty: form.qty,
      }
      return dineInAxios
        .put(url, payload)
        .then((res) => {
          if (res.msg == false) return false
          return res.data;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    fetchStoreSpecialCloseList({ commit }, { store_id }) {
      let url = `/api/v1/dine-in/store/special/closeTime/${store_id}`;
      return dineInAxios
        .get(url)
        .then((res) => {
          if (res.msg == false) return;
          return res.data;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    fetchStoreSpecialCloseById({ commit }, { store_id, special_close_id }) {
      let url = `/api/v1/dine-in/store/special/closeTime/detail/${store_id}/${special_close_id}`;
      return dineInAxios
        .get(url)
        .then((res) => {
          if (res.msg == false) return;
          return res.data;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    createStoreSpecialClose({ commit }, { store_id, dateTime, startTime, endTime, description }) {
      let url = `/api/v1/dine-in/store/special/closeTime`;
      let payload = {
        store_id, dateTime, startTime, endTime, description
      };
      return dineInAxios
        .post(url, payload)
        .then((res) => {
          if (res.msg == false) return;
          return res.data;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    removeStoreSpecialClose({ commit }, { store_id, special_close_id }) {
      let url = `/api/v1/dine-in/store/special/closeTime/detail/${store_id}/${special_close_id}`;
      return dineInAxios
        .delete(url)
        .then((res) => {
          return res.msg;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    updateStoreSpecialClose({ commit }, { special_close_id, store_id, dateTime, startTime, endTime, description }) {
      let url = `/api/v1/dine-in/store/special/closeTime/detail/${store_id}/${special_close_id}`;
      let payload = {
        dateTime, startTime, endTime, description
      };
      return dineInAxios
        .put(url, payload)
        .then((res) => {
          if (res.msg == false) return;
          return res.data;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    fetchStoreCategory({ commit }) {
      let url = `/api/v1/dine-in/manage/foodCategory`;
      return dineInAxios
        .get(url)
        .then((res) => {
          if (res.msg == false) return;
          commit('setStoreCategory', res.data)
          return res.data;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    createStoreCategory({ commit }, { store_category_name_th, store_category_name_en, store_category_image, store_category_status }) {
      let url = `/api/v1/dine-in/manage/foodCategory`;
      let payload = {
        "store_category_name_th": store_category_name_th,
        "store_category_name_en": store_category_name_en,
        "store_category_image": store_category_image,
        "store_category_status": store_category_status,
      }

      return dineInAxios
        .post(url, payload)
        .then((res) => {
          if (res.msg == false) return;
          commit('addStoreCategory', res.data)
          return res.data;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    updateStoreCategory({ commit }, { store_category_id, store_category_name_th, store_category_name_en, store_category_image, store_category_status }) {
      let url = `/api/v1/dine-in/manage/foodCategory`;
      let payload = {
        "store_category_id": store_category_id,
        "store_category_name_th": store_category_name_th,
        "store_category_name_en": store_category_name_en,
        "store_category_image": store_category_image,
        "store_category_status": store_category_status
      }
      return dineInAxios
        .put(url, payload)
        .then((res) => {
          if (res.msg == false) return;
          commit('editStoreCategory', res.data)
          return res.data;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    removeStoreCategory({ commit }, store_category_id) {
      let url = `/api/v1/dine-in/manage/foodCategory?store_category_id=${store_category_id}`;
      return dineInAxios
        .delete(url)
        .then((res) => {
          commit('deleteStoreCategory', store_category_id)
          return res.msg;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    approveOrder({ commit }, { order_id, order_status }) {
      let url = `/api/v1/dine-in/office/approveOrder/${order_id}`;
      let payload = {
        "order_status": "onprocessing"
      }
      return dineInAxios
        .put(url, payload)
        .then((res) => {
          if (order_status == 1) {
            commit('changeStatusOrderNewOrder', order_id)
          } else if (order_status == 2) {
            commit('changeStatusOrderOnProcess', order_id)
          }
          return res.msg;
        })
        .catch((error) => false);
    },
    resendEmailDineIn({ commit }, { order_id }) {
      let url = `/api/v1/dine-in/office/resendEmail/${order_id}`;
      return dineInAxios
        .get(url)
        .then((res) => {
          return res.msg;
        })
        .catch((error) => false);
    },
    fetchStoreDistrictList({ }) {
      let url = `/api/v1/dine-in/manage/store/district`;
      return dineInAxios
        .get(url)
        .then((res) => {
          if (res.msg == false) return false
          return res.data;
        })
        .catch((error) => false);
    },
    createStoreDistrictList({ }, { store_district_district_id, store_district_image }) {
      let url = `/api/v1/dine-in/manage/store/district`;
      let payload = { store_district_district_id, store_district_status: 1 }
      if (store_district_image) payload.store_district_image = store_district_image
      return dineInAxios
        .post(url, payload)
        .then((res) => {
          if (res.msg == false) return false
          return res.data;
        })
        .catch((error) => false);
    },
    updateStoreDistrictList({ }, { store_district_id, store_district_district_id, newStoreDistrictImage }) {
      let url = `/api/v1/dine-in/manage/store/district`;
      let payload = {
        store_district_id,
        "store_district_district": store_district_district_id,
        "store_district_status": 1,
      }
      if (newStoreDistrictImage) payload.store_district_image = newStoreDistrictImage
      return dineInAxios
        .put(url, payload)
        .then((res) => {
          if (res.msg == false) return false
          return res.data;
        })
        .catch((error) => false);
    },
    removeStoreDistrict({ }, store_district_id) {
      let url = `/api/v1/dine-in/manage/store/district?store_district_id=${store_district_id}`;
      return dineInAxios
        .delete(url)
        .then((res) => {
          return res.msg;
        })
        .catch((error) => false);
    },
    async getAllDineInReviews({ commit }, payload) {
      let url = "/api/v1/dine-in/reviews";
      return dineInAxios
        .get(url, { params: payload })
        .then((res) => {
          if (res.msg === false) return false;
          else {
            commit("getAllDineInReviews", res.data);
            return res.data;
          }
        })
        .catch((error) => false);
    },
    changeReviewStatus({ commit }, payload) {
      let url = `/api/v1/dine-in/manage/status/review`;

      return dineInAxios
        .put(url, payload.data)
        .then((res) => {
          if (res.msg == true && res.data == "review error") {
            return false;
          } else if (res.data == true && res.data == "review success") {
            return true;
          } else {
            return res.msg;
          }
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    createCampaignReviewBenefit({ commit }, payload) {
      let url = '/api/v1/dine-in/create_campaign_review';
      let body = {
        "campaign_review_province": [],
        "campaign_review_name_th": "",
        "campaign_review_name_en": "",
        "campaign_review_description_th": "",
        "campaign_review_description_en": "",
        "campaign_review_highlight_th": "",
        "campaign_review_highlight_en": "",
        "campaign_review_condition_detail_list": [],
        "campaign_review_level": [],
        "campaign_review_category": 6,
        "campaign_review_total_amount": "1",
        "campaign_review_redeemable_amount_per_user": 1,
        "campaign_review_start_date": "",
        "campaign_review_end_date": "",
        "campaign_review_base_point": "0",
        "campaign_review_promotion_code": "DRWB",
        "campaign_review_promotion_type": 1,
        "campaign_review_promotion_category": 1,
        "campaign_review_promotion_unit": null,
        "campaign_review_promotion_fix_price": 0,
        "campaign_review_promotion_condition": [],
        "campaign_review_reward_life_span": {
          'amount': 0,
          "unit": 'day'
        }
      }

      Object.assign(body, payload);
      body.campaign_review_reward_life_span.amount = parseInt(body.campaign_review_reward_life_span.amount)
      return dineInAxios
        .post(url, body)
        .then((res) => {
          if (res.msg == false) return false;
          commit('addCampaignReviewBenefitList', res.data)
          return res.data;

        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    fetchCampaignReviewBenefit({ commit }) {
      let url = `/api/v1/dine-in/get_campaign_review_list`;
      return dineInAxios
        .get(url)
        .then((res) => {
          if (res.msg == false) return false
          commit('setCampaignReviewBenefitList', res.data);
          return res.data;
        })
        .catch((error) => false);
    },
    changeStatusCampaignReview({ commit }, campaign_review_id) {
      let url = `/api/v1/dine-in/update_status_campaign_review/${campaign_review_id}`;
      return dineInAxios
        .put(url, {})
        .then((res) => {
          return res.msg;
        })
        .catch((error) => false);
    },
    removeCampaignReviewBenefit({ commit }, campaign_review_id) {
      let url = `/api/v1/dine-in/delete_campaign_review/${campaign_review_id}`;
      return dineInAxios
        .delete(url)
        .then((res) => {
          if (res.msg == false) return false;
          commit('deleteCampaignReviewBenefitList', campaign_review_id)
          return true;
        })
        .catch((error) => false);
    },
    updateCampaignReviewBenefit({ commit }, payload) {
      let url = '/api/v1/dine-in/update_campaign_review';
      let body = {
        "campaign_review_id": -1,
        "campaign_review_province": [],
        "campaign_review_name_th": "",
        "campaign_review_name_en": "",
        "campaign_review_description_th": "",
        "campaign_review_description_en": "",
        "campaign_review_highlight_th": "",
        "campaign_review_highlight_en": "",
        "campaign_review_condition_detail_list": [],
        "campaign_review_level": [],
        "campaign_review_category": 6,
        "campaign_review_total_amount": "1",
        "campaign_review_redeemable_amount_per_user": 1,
        "campaign_review_start_date": "",
        "campaign_review_end_date": "",
        "campaign_review_base_point": "0",
        "campaign_review_promotion_code": "DRWB",
        "campaign_review_promotion_type": 1,
        "campaign_review_promotion_category": 1,
        "campaign_review_promotion_unit": null,
        "campaign_review_promotion_fix_price": 0,
        "campaign_review_promotion_condition": [],
        "campaign_review_reward_life_span": {
          'amount': 0,
          "unit": 'day'
        }
      }

      Object.assign(body, payload);
      body.campaign_review_reward_life_span.amount = parseInt(body.campaign_review_reward_life_span.amount)
      return dineInAxios
        .put(url, body)
        .then((res) => {
          if (res.msg == false) return false
          commit('editCampaignReviewBenefitList', body)
          return true;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    fetchCampaignReviewBenefitById({ }, campaign_review_id) {
      let url = `/api/v1/dine-in/get_campaign_review_detail/${campaign_review_id}`
      return dineInAxios
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          return res.data;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    },
    fetchCampaignUsedLog({ }, { campaign_review_id, page, page_size }) {
      let url = `/api/v1/dine-in/get_review_log_campaign_review/${campaign_review_id}`
      return dineInAxios
        .get(url, { params: { page, page_size } })
        .then((res) => {
          if (res.msg == false) return false;
          return res;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    }
  },
};
